import { SharedMakeupsTable } from '@/components/shared/makeups-table';
import type { MakeupItem } from '@/components/shared/makeups-table';

interface MakeupsTableProps {
  title: string;
  description: string;
  makeups: MakeupItem[];
  variant: 'pending' | 'scheduled' | 'history';
  onSchedule?: (makeupId: string) => void;
  onComplete?: (makeupId: string) => void;
  onWaive?: (makeupId: string) => void;
}

export function MakeupsTable({
  title,
  description,
  makeups,
  variant,
  onSchedule,
  onComplete,
  onWaive,
}: MakeupsTableProps) {
  return (
    <SharedMakeupsTable
      title={title}
      description={description}
      makeups={makeups}
      variant={variant}
      onSchedule={onSchedule}
      onComplete={onComplete}
      onWaive={onWaive}
    />
  );
}
